import Dashboard from "@/statistics/Dashboard";

export default [
    {
        path: '/dashboard',
        component: Dashboard
    },
];
